"use client";

import { Leaf, Rabbit, BadgeCheck, Cloud, Droplet, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const badges = [{
  icon: BadgeCheck,
  label: "PROFECO Compliant"
}, {
  icon: Leaf,
  label: "SAT Registered"
}, {
  icon: BadgeCheck,
  label: "29 YRS EXPERTISE"
}, {
  icon: Cloud,
  label: "Legal Compliance"
}, {
  icon: Droplet,
  label: "Zero Upfront Cost"
}];
export default function OurCredentials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="448" id="our-credentials" className="bg-background text-foreground py-16 md:py-20">
      <div ref={ref} className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        {}
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <span className="text-[10px] md:text-xs font-mono uppercase tracking-[0.25em] font-default" style={{
          color: "var(--primary)"
        }}>
            Institutional Authority
          </span>
          <Link to="/ContactPage" className="group inline-flex items-center gap-2 text-[10px] md:text-xs font-mono uppercase tracking-[0.25em] transition-colors font-default" style={{
          color: "var(--foreground)"
        }}>
            <span className="transition-opacity group-hover:text-[color:var(--primary)]">
              View Compliance Docs
            </span>
            <ArrowRight className="size-3 transition-transform group-hover:translate-x-1" style={{
            color: "var(--primary)"
          }} />
          </Link>
        </div>

        {}
        <div aria-hidden="true" className="h-px w-full" style={{
        backgroundColor: "var(--border)"
      }} />

        {}
        <div className="py-10 md:py-14">
          {}
          <div className="md:hidden -mx-4 px-4 overflow-x-auto scrollbar-thin">
            <ul className="flex items-start gap-10 min-w-max pb-2">
              {badges.map((badge, i) => {
              const Icon = badge.icon;
              return <li key={badge.label} data-index={i} className="group flex flex-col items-center text-center w-28 shrink-0">
                    <Icon strokeWidth={1.25} className="size-10 mb-4 transition-transform duration-300 group-hover:-translate-y-1" style={{
                  color: "var(--primary)"
                }} />
                    <span className="text-[10px] font-mono uppercase tracking-[0.18em] leading-relaxed transition-colors duration-300 group-hover:text-[color:var(--primary)] font-default" style={{
                  color: "var(--foreground)"
                }}>
                      {badge.label}
                    </span>
                  </li>;
            })}
            </ul>
            <div className="mt-3 mx-auto h-0.5 w-12 rounded-md" style={{
            backgroundColor: "var(--primary)"
          }} aria-hidden="true" />
          </div>

          {}
          <ul className="hidden md:flex items-start justify-center gap-12 lg:gap-16 xl:gap-20">
            {badges.map((badge, i) => {
            const Icon = badge.icon;
            return <li key={badge.label} data-index={i} className="group flex flex-col items-center text-center">
                  <Icon strokeWidth={1.25} className="size-12 mb-5 transition-transform duration-300 ease-out group-hover:-translate-y-1" style={{
                color: "var(--primary)"
              }} />
                  <span className="text-[11px] font-mono uppercase tracking-[0.22em] transition-colors duration-300 group-hover:text-[color:var(--primary)] font-default" style={{
                color: "var(--foreground)"
              }}>
                    {badge.label}
                  </span>
                </li>;
          })}
          </ul>
        </div>

        {}
        <div aria-hidden="true" className="h-px w-full" style={{
        backgroundColor: "var(--border)"
      }} />
      </div>
    </section>;
}